export const REGLEMENT_FALLBACK_IMAGE = "/img/article_placeholder.jpg";

export const DEFAULT_REGLEMENT_SETTINGS = {
  reglement_interieur: "",
  reglement_interieur_url_header: "",
  reglement_interieur_url_firstimage: "",
  reglement_interieur_url_secondimage: "",
};

export const REGLEMENT_UPLOAD_TARGETS = {
  header: {
    key: "header",
    label: "Image d’en-tête",
    hint: "Grand visuel bannière recommandé : format paysage, environ 1920×600.",
    field: "reglement_interieur_url_header",
  },
  first: {
    key: "first",
    label: "Première image",
    hint: "Image d’illustration principale : format paysage, environ 1280×720.",
    field: "reglement_interieur_url_firstimage",
  },
  second: {
    key: "second",
    label: "Deuxième image",
    hint: "Image complémentaire pour illustrer une seconde partie du règlement.",
    field: "reglement_interieur_url_secondimage",
  },
};

export const REGLEMENT_QUILL_MODULES = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
};

export const REGLEMENT_QUILL_FORMATS = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "color",
  "background",
  "script",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
];

export function unwrapSettings(data) {
  if (Array.isArray(data)) return data[0] || null;
  return data || null;
}

export function withBust(url, version) {
  if (!url) return url;
  return `${url}${url.includes("?") ? "&" : "?"}v=${version}`;
}

export function stripHtml(value = "") {
  return String(value)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function validateImageFile(file) {
  if (!file) return "Veuillez sélectionner une image.";

  const validType = /^image\/(png|jpe?g|webp)$/i.test(file.type);

  if (!validType) {
    return "Format non supporté. Utilisez PNG, JPG ou WEBP.";
  }

  if (file.size > 10 * 1024 * 1024) {
    return "Fichier trop volumineux. Taille maximale : 10 Mo.";
  }

  return "";
}

export function normalizeReglementPayload(settings) {
  return {
    ...settings,
    reglement_interieur: String(settings?.reglement_interieur || ""),
    reglement_interieur_url_header: String(
      settings?.reglement_interieur_url_header || ""
    ).trim(),
    reglement_interieur_url_firstimage: String(
      settings?.reglement_interieur_url_firstimage || ""
    ).trim(),
    reglement_interieur_url_secondimage: String(
      settings?.reglement_interieur_url_secondimage || ""
    ).trim(),
  };
}